import { render } from "./fflink.vue?vue&type=template&id=6ec49ce4"
import script from "./fflink.vue?vue&type=script&lang=js"
export * from "./fflink.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\FFSTAR3\\VUESP\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__